import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Form } from "react-bootstrap";
import "./Intermediat_Check_Form.css";
import Select from "react-select";

function Intermediat_Check_Form({ onProceed }) {
  const instrumentOptions = [
    { value: "ika_bomb", label: "Ika Bomb Calorimeter" },
    { value: "balance", label: "Electronic Balance" },
  ];

  return (
    <>
      <section className="Legal_Entity_Form">
        <div className="white_container customer_section">
          <div className="row">

            {/* Instrument */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Instrument</Form.Label>
                <Select
                  options={instrumentOptions}
                  placeholder="Select Instrument"
                  classNamePrefix="react_select"
                />
              </Form.Group>
            </div>

            {/* Instrument ID */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Instrument ID</Form.Label>
                <Form.Control placeholder="Instrument ID" />
              </Form.Group>
            </div>

            {/* Calibrate Instrument */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Calibrate Instrument</Form.Label>
                <Form.Control placeholder="Enter Calibrate Instrument" />
              </Form.Group>
            </div>

          </div>

          {/* Buttons */}
          <div className="permission_btn_holder">
            <Button className="permission_btn No_btn">Cancel</Button>
            <Button
              className="permission_btn Yes_btn"
              onClick={onProceed}
            >
              Proceed
            </Button>
          </div>
        </div>
      </section>
    </>
  );
}

export default Intermediat_Check_Form;
